module.exports = __webpack_public_path__ + "img/MapPicsGhostLake.eaa3cdbd.webp";